<section #chartContainer class="row table-header align-items-bottom" [ngStyle]="{ height: height }">
	<ng-container *ngTemplateOutlet="header; context: { headerText: ((tabData?.tableData)[0]?.headersX)[0] }"></ng-container>
	<ng-container *ngIf="noOfPortfolios >= 2">
		<ng-container *ngTemplateOutlet="header; context: { headerText: ((tabData?.tableData)[0]?.headersX)[1] }"></ng-container>
	</ng-container>
</section>
<section class="row">
	<div (mouseenter)="onMouseEvent($event, 0)" (mouseleave)="onMouseEvent($event, 0)" (mousemove)="onMouseEvent($event, 0)" class="col-12">
		<div #chartCanvas1 width="250" height="250"></div>
	</div>
	<div class="col-12" (mouseenter)="onMouseEvent($event, 1)" (mouseleave)="onMouseEvent($event, 1)" (mousemove)="onMouseEvent($event, 1)" [hidden]="noOfPortfolios < 2">
		<div #chartCanvas2 width="250" height="250"></div>
	</div>
</section>

<section class="row table-header align-items-bottom" *ngIf="noOfPortfolios >= 3">
	<ng-container *ngTemplateOutlet="header; context: { headerText: ((tabData?.tableData)[0]?.headersX)[2] }"></ng-container>
	<ng-container *ngIf="noOfPortfolios >= 4">
		<ng-container *ngTemplateOutlet="header; context: { headerText: ((tabData?.tableData)[0]?.headersX)[3] }"></ng-container>
	</ng-container>
</section>
<section class="row">
	<div class="col-12" (mouseenter)="onMouseEvent($event, 2)" (mouseleave)="onMouseEvent($event, 2)" (mousemove)="onMouseEvent($event, 2)" [hidden]="noOfPortfolios < 3">
		<div #chartCanvas3 width="250" height="250"></div>
	</div>
	<div class="col-12" (mouseenter)="onMouseEvent($event, 3)" (mouseleave)="onMouseEvent($event, 3)" (mousemove)="onMouseEvent($event, 3)" [hidden]="noOfPortfolios < 4">
		<div #chartCanvas4 width="250" height="250"></div>
	</div>
</section>

<ng-template #header let-headerText="headerText">
	<section class="col-12 text-14-bold text-align-center">
		<span [forcedLineBreak]="headerText?.formattedValue" class="padding-bottom-10"></span>
		<icon
			type="info-circle"
			class="info-circle text-14 color-primary"
			*ngIf="header?.config?.infoBubble"
			[tooltip]="headerText?.config?.infoBubble?.defaultText"
			[analytic-data]="{ linkName: 'tooltip_' + headerText?.formattedValue }">
		</icon>
	</section>
</ng-template>

<ac-style-box-tooltip
	*ngIf="!!contributionTooltipData"
	#contributionTooltip
	[data]="contributionTooltipData"
	[parentData]="data"
	[customTooltipOffset]="customTooltipOffset"
	[productNameCharacterLimit]="productNameCharacterLimit"
	[tooltipWidth]="tooltipWidth">
</ac-style-box-tooltip>
